import cx from 'clsx';
import React from 'react';

import { ReactComponent as EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D111.svg';
import { ReactComponent as D116EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D116.svg';
import { ReactComponent as D134EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D134.svg';
import { ReactComponent as D136EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D136.svg';
import { ReactComponent as IndicatorIcon } from '@assets/svg/sensors-temperature/indicator.svg';

import DowntimeIndicators from '../DowntimeIndicators/DowntimeIndicators';
import style from './style.module.scss';

interface IProps {
  userMetric: string;
}

const FirstRow: React.FC<IProps> = ({ userMetric }) => {
  return (
    <div className={style.row}>
      <div className={style.cell}>
        <div className={style.runningTextContainer}>
          <span>Incline CV Running</span> <span>Running</span>
        </div>
      </div>
      <div className={style.cell}>
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-131</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-132</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-133</span>
          <div className={style.equipmentIconContainer}>
            <D134EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-134</span>
          <div className={style.equipmentIconContainer}>
            <D134EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={style.sensorsEquipmentItemContainer}>
          <span className={style.name}>D-135</span>
          <div className={style.equipmentIconContainer}>
            <D116EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <div className={style.sensorsEquipmentItemContainer}>
          <span className={style.name}>D-136</span>
          <div className={style.equipmentIconContainer}>
            <D136EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={cx(style.cell, style.downtimeIndicatorsCell)}>
        <div className={style.downtimeIndicatorsWrapper}>
          <DowntimeIndicators />
        </div>
      </div>
    </div>
  );
};

export default FirstRow;
